import React, { useContext, useState } from "react";
import { toast as showToast } from "react-toastify";

interface IAscContext {
  navigateFunction: (path: string) => void;
  theme?: "light" | "dark";
  setTheme?: (theme: "light" | "dark") => void;
  linkComponentWrapper: (
    props: React.DetailedHTMLProps<
      React.AnchorHTMLAttributes<HTMLAnchorElement>,
      HTMLAnchorElement
    >
  ) => JSX.Element;
  toast: typeof showToast;
}
const AscContext = React.createContext<IAscContext>({
  navigateFunction: (path: string) => ({}),
  linkComponentWrapper: ({ children }) => <>{children}</>,
  theme: "light",
  toast: showToast,
});

interface AscProviderProps {
  children: React.ReactNode;
  navigateFunction: (path: string) => void;
  theme?: "light" | "dark";
  setTheme?: (theme: "light" | "dark") => void;
  linkComponentWrapper: (
    props: React.DetailedHTMLProps<
      React.AnchorHTMLAttributes<HTMLAnchorElement>,
      HTMLAnchorElement
    >
  ) => JSX.Element;
}

function AscProvider({
  children,
  navigateFunction,
  linkComponentWrapper,
}: AscProviderProps) {
  const [theme, setTheme] = useState<"light" | "dark">("light");
  return (
    <AscContext.Provider
      value={{
        navigateFunction,
        theme,
        setTheme,
        linkComponentWrapper,
        toast: showToast,
      }}
    >
      <div className={`${theme}-mode`}>{children}</div>
    </AscContext.Provider>
  );
}

function useAscContext() {
  return useContext(AscContext);
}

export { AscProvider, AscContext, useAscContext };
